export default "__VITE_ASSET__B5$Rl9SB__"